import React, { createRef, Component } from "react";
import ImageHeroContainer from "./../shared/containers/ImageHeroContainer";
import Store from "../../content/Store";
import OuterPrimaryContainer from "../shared/containers/OuterPrimaryContainer";
import contentify from "../../content/Contentify";
import { Paths } from "./../../constants/UrlConstants";
import HelpSection from "./../shared/HelpSection";
import styles from "../../assets/css/modules/health-support/ask-a-medical-expert.css";
import { connect } from "react-redux";
import Button from "./../shared/buttons/Button";
import { withRouter } from "react-router-dom";
import { ButtonConfig, InboxPages } from "../../constants/Constants";
import { Urls } from "../../constants/UrlConstants";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import PromoImageCard from "../../components/shared/PromoImageCard";
import MskSection from "../shared/MskSection";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";
import { getLayout } from "../../layout/Layout";
import { Layouts } from "../../constants/Constants";

export const mapStateToAskAMedicalExpert = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
    const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
      selectedPolicy
    );
    const isAgeAbove18 = DateHelper.isAgeAbove18(loggedInMember.DateOfBirth);

  return {
    isInternational: selectedPolicy && selectedPolicy.IsInternational,
    layout: state.layoutReducer && state.layoutReducer.layout,
    featureFlagEP : state && state.unreadMessagesReducer && state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer &&
    state.policyReducer.policyDetails &&
    state.policyReducer.policyDetails.IsInternalView,
    isLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    isAgeAbove18
  };
};

const shouldAlignSpeaktoExperiencedCancerNursePromoAnyLeft = ({
  shouldRenderExperiencedCancerNursePromo
}) => {
  return !shouldRenderExperiencedCancerNursePromo;
};

const shouldAlignSpeaktoExperiencedHeartNursePromoAnyLeft = ({

  shouldRenderExperiencedCancerNursePromo
}) => {
  return (
    shouldRenderExperiencedCancerNursePromo
  );
};
const scrollDiv = createRef();
const  scrollSmoothHandler = () => {
  scrollDiv.current.scrollIntoView({ behavior: "smooth" });
};
export class AskAMedicalExpert extends Component {
  static content = {
    ...Store.AskAMedicalExpert,
    ...Store.Home.Cards};
  constructor(props) {
    super(props);
    this.state={
      urlSendMessage : Urls.EngagementPortal[EPDomain_ROOT].new,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  handleCallbackSendMessage = (data) => {
    this.setState({ urlSendMessage: data });
  };
  onButtonClick(uri) {
    window.open(uri);
  }
  onSubmit() {
    if(this.props.featureFlagEP === false || this.props.featureFlagEP === undefined){
    this.props.history.push(
      `${Paths.Inbox}?page=${InboxPages.AskAMedicalExpertPage}`
    );
    } else if(this.props.featureFlagEP === true){
      window.open(this.state.urlSendMessage, "_blank", "noopener");
    }
  }
  onSurveyButtonClick() {
    window.open(Urls.AXAHealthAtHandSurvey, "_blank");
  }
  render() {
    return (
      <div className={styles.askAMedicalExpert}>
        <OuterPrimaryContainer>
          <ImageHeroContainer
            bgImage={this.props.content.BackgroundDesktopImage}
            bgImageMobile={this.props.content.BackgroundMobileImage}
            bgImageTablet={this.props.content.BackgroundTabletImage}
            bgAlt=""
            styleOverrides={styles.askAMedicalExpert}
            Healthsupportline1="Healthsupportline"
          >
            {this.props.content.HeroContent}
            <div className={"container " + styles.buttonRowSpacing}>
              <div className="row">
                  <div className="col-lg-12 p-0">
                    <div style={{ textAlign: "center" }}>
                      <Button
                        buttonType="primaryBlueButton"
                        label={this.props.content.AskAMedicalExpet}
                        Healthsupportline1="Healthsupportline"
                        ClassName="icon-phone"                        
                      />
                      <Button
                        buttonType={this.props.content.SupportButtonType}
                        onClick={this.onSubmit}
                        label={this.props.content.SendAMessage}
                        Healthsupportline1="Healthsupportline"
                        ClassName={this.props.content.IconType}
                        id={ButtonConfig.TwentyfourMessh}
                        disabled={this.props.IsInternalView}
                        IsInternalView={this.props.IsInternalView}
                      />
                    </div>
                  </div>
              </div>
            </div>
          </ImageHeroContainer>
          <EPQueryParams url={this.state.urlSendMessage} messageType="askMedicalQuestion" updatedURL={this.handleCallbackSendMessage}/>
          <section className={styles.sectionSpacingHelpSection}>
            <div className="OAD-message-styles">
              <h3 className={styles.askAMedicalExpertHeading}>
                {this.props.content.EmergenciesHeading}
              </h3>
              {this.props.content.EmergenciesDescription}
            </div>
          </section>
          <section className={styles.sectionSpacingHelpSection} ref={scrollDiv}>
            <h2 className={styles.askAMedicalExpertHeading}>
              {this.props.content.Section1Heading}
            </h2>
            {this.props.content.Section1Description}
          </section>
            <React.Fragment>
              <section className={styles.sectionSpacingHelpSection}>
                <h2 className={styles.askAMedicalExpertHeading}>
                  {this.props.content.Section2Heading}
                </h2>
                <p>{this.props.content.Section2Description}</p>
                <div className="row">
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <Button
                      buttonType="primaryBlueButton"
                      label={this.props.content.AskAMedicalExpetCall}
                      Healthsupportline1="Healthsupportline"
                      ClassName="icon-phone"                      
                    />
                    <Button
                      buttonType={this.props.content.SupportButtonType}
                      onClick={this.onSubmit}
                      label={this.props.content.SendAMessage}
                      Healthsupportline1="Healthsupportline"
                      ClassName={this.props.content.IconType}
                      id={ButtonConfig.TwentyfourMessb}
                      disabled={this.props.IsInternalView}
                      IsInternalView={this.props.IsInternalView}
                    />
                  </div>
                </div>
              </section>
            </React.Fragment>
          <div className="container">
            <div className="row">
              <div id="promoImageCardSupport" className="col-sm-12">
                <PromoImageCard
                  ImgSrc={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.IconSrc}
                  ImgSrcMobile={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.IconSrcMobile}
                  Heading={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.Heading}
                  Description1={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.Description1}
                  Description2={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.Description2}
                  Description3={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.Description3}
                  LinkText={<Button
                    buttonType="primaryOrangeButton"
                    label={this.props.content.SpeaktoExpCancerNurse}
                    Healthsupportline1="Healthsupportline"
                    ClassName="icon-phone"
                    id={ButtonConfig.Twentyfourcallc4c}
                  />}
                  LinkTo={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse}
                  aria-label={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.AriaLabel}
                  LeftImage={shouldAlignSpeaktoExperiencedCancerNursePromoAnyLeft(this.props)}
                  promoImageCardSupport="promoImageCardSupport"
                  scrollSmoothHandler={scrollSmoothHandler}
                  HealthSupportScroll={true}
                />
              </div>
            </div>
            <div className="row">
              <div id="healthStorePromo" className="col-sm-12">
                <PromoImageCard
                  ImgSrc={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedHeartNurse.IconSrc}
                  ImgSrcMobile={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedHeartNurse.IconSrcMobile}
                  Heading={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedHeartNurse.Heading}
                  Description1={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedHeartNurse.Description1}
                  Description2={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedHeartNurse.Description2}
                  Description3={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedHeartNurse.Description3}
                  LinkText={<Button
                    buttonType="primaryOrangeButton"
                    label={this.props.content.SpeaktoExpHeartNurse}
                    Healthsupportline1="Healthsupportline"
                    id={ButtonConfig.Twentyfourcallcardiac}
                    ClassName="icon-phone"
                  />}
                  LinkTo={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse}
                  aria-label={Store.AskAMedicalExpert.Cards.SpeaktoExperiencedCancerNurse.AriaLabel}
                  LeftImage={shouldAlignSpeaktoExperiencedHeartNursePromoAnyLeft(this.props)}
                  promoImageCardSupport="promoImageCardSupport"
                  scrollSmoothHandler={scrollSmoothHandler}
                  HealthSupportScroll={true}
                />
              </div>
            </div>
            <section className={styles.sectionSpacingHelpSectionFAQ}>
              <HelpSection
                HelpSet={this.props.content.HelpSet}
                Healthsupportline="Healthsupportline"
                className={styles.HelpLineSpacing}
              />
            </section>
            {!this.props.isLapsed && (this.props.isAgeAbove18 ?<MskSection accessPage={Paths.WorkingBody} UniqueKey="mskBanner" layout={this.props.layout}/>:
            (<PromoImageCard
              ImgSrc={Store.PromoCards.AccessHealthSupportSrc.IconSrc}
              ImgSrcMobile={
                Store.PromoCards.AccessHealthSupportSrc.IconSrcMobile
              }
              Heading={Store.PromoCards.AccessHealthSupportSrc.Heading}
              Description={
                Store.PromoCards.AccessHealthSupportSrc.Description
              }
              LinkText={Store.PromoCards.AccessHealthSupportSrc.LinkText}
              LinkTo={getLayout()===Layouts.HOL ?  Store.PromoCards.AccessHealthSupportSrc.LinkToHOL : Store.PromoCards.AccessHealthSupportSrc.LinkTo}
              LeftImage
            />
            ))}
          </div>
        </OuterPrimaryContainer>
      </div>
    );
  }
}

export default connect(mapStateToAskAMedicalExpert)(
  withRouter(contentify(AskAMedicalExpert))
);
